import React from 'react';
import Icon from './Error.svg';

export default (props) => <Icon {...props} />;
